/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import { deepClone, getSessionDatas, isStringEmpty } from './index';
import { covertStringToDate, isDate } from './ValidationUtils';

/*if (!Array.prototype.find) {
    Array.prototype.find = function(fn){
        let obj = null;
        for(let i=0;i<this.length;i++){
            const _obj = this[i];
            if (fn(_obj)) {
                obj = _obj;
                break;
            }
        }
        return obj;
    }
}

if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function(fn){
        let index = -1;
        for(let i=0;i<this.length;i++){
            if (fn(this[i])) {
                index = i;
                break;
            }
        }
        return index;
    }
}*/
let _tempItem = null

export const arrayFind = (targetArray, contrast, key)=> {
    let obj = null;
    for (let i=0; i<targetArray.length; i++) {
        const _obj = targetArray[i];
        const cc = typeof _obj==='object' ? _obj[key] : _obj;

        if (cc === contrast) {
            obj = _obj;
            break;
        }
    }
    return obj;
};

export const arrayFindIndex = (targetArray, contrast, key)=> {
    let index = -1;
    for (let i=0; i<targetArray.length; i++) {
        const _obj = targetArray[i];
        const cc = typeof _obj==='object' ? _obj[key] : _obj;

        if (cc === contrast) {
            index = i;
            break;
        }
    }
    return index;
};

export const arrayRemoveEmptyElement = (targetArray)=> {
    for (let i=0; i<targetArray.length; i++) {
        if(targetArray[i] === undefined || targetArray[i] === null) {
            targetArray.splice(i,1);
            i = i - 1;
        }
    }
    return targetArray;
};

export const findQuestionById = (app, id) => {
    const { qIds } = parseId(id);
    let result = null;
    const section = app.sections && arrayFind(app.sections, 'S' + qIds[0], 'sectionId');

    if (section && qIds.length > 1) {
        const rootQuestion = arrayFind(section.questions, 'Q' + qIds[0] + '-' + qIds[1], 'questionId');

        if (qIds.length > 2) {
            let _question = null;
            for (let i = 2; i < qIds.length; i++) {
                const q = _question === null ? rootQuestion : _question;
                if (q.subQuestions===null) {
                    _question = null;
                    break;
                }
                let _qId = 'Q' + qIds[0];
                for(let j=1;j<=i;j++){
                    _qId += '-' + qIds[j];
                }
               _question = arrayFind(q.subQuestions, _qId, 'questionId');
            }
            result = _question;
        } else {
            result = rootQuestion;
        }
    } else {
        result = section
    }

    return result;
};

export const findQuestionByIdInSubSection = (subSecton, id) => {
    const { qIds } = parseId(id);
    let result = null;

    if (subSecton && qIds.length > 2) {
        const rootQuestion = arrayFind(subSecton.subQuestions, 'Q' + qIds[0] + '-' + qIds[1] + '-' + qIds[2] , 'questionId');

        if (qIds.length > 3) {
            let _question = null;
            for (let i = 2; i < qIds.length; i++) {
                const q = _question === null ? rootQuestion : _question;
                if (q.subQuestions===null) {
                    _question = null;
                    break;
                }
                let _qId = 'Q' + qIds[0];
                for(let j=1;j<=i;j++){
                    _qId += '-' + qIds[j];
                }
               _question = arrayFind(q.subQuestions, _qId, 'questionId');
            }
            result = _question;
        } else {
            result = rootQuestion;
        }
    } else {
        result = subSecton
    }

    return result;
}

export const findQuestionByIdInSection = (section, id) => {
    const { qIds } = parseId(id);
    let result = null;
    if (section && qIds.length > 1) {
        const rootQuestion = arrayFind(section.questions, 'Q' + qIds[0] + '-' + qIds[1], 'questionId');

        if (qIds.length > 2) {
            let _question = null;
            for (let i = 2; i < qIds.length; i++) {
                const q = _question === null ? rootQuestion : _question;
                if (q.subQuestions===null) {
                    _question = null;
                    break;
                }
                let _qId = 'Q' + qIds[0];
                for(let j=1;j<=i;j++){
                    _qId += '-' + qIds[j];
                }
                _question = arrayFind(q.subQuestions, _qId, 'questionId');
            }
            result = _question;
        } else {
            result = rootQuestion;
        }
    } else {
        result = section
    }

    return result;
};

export const parseId = (id) => {
    const type = id.substr(0, 1);
    const ids = id.slice(1).split(':');
    const qid = ids[0];
    const qIds = qid.split('-');
    let aId = null;
    if (ids.length > 0) {
        aId = ids[1];
    }

    return {
        type,
        qIds,
        aId
    };
};

export const replaceQuestion = (app, question) => {
    let newApp = deepClone(app);
    const { qIds } = parseId(question.questionId);
    const section = arrayFind(newApp.sections, 'S' + qIds[0], 'sectionId');
    const index = arrayFindIndex(section.questions, question.questionId, 'questionId');

    section.questions.splice(index, 1, question);
    return newApp;
};

export const replaceSection = (app, section) => {
    let newApp = deepClone(app);
    let index = arrayFindIndex(newApp.sections, section.sectionId, 'sectionId');
    newApp.sections.splice(index, 1, section);
    return newApp;
};

export const replaceSubQuestion = (app, question) => {
    let newApp = deepClone(app);
    const { qIds } = parseId(question.questionId);
    const section = arrayFind(newApp.sections, 'S' + qIds[0], 'sectionId');
    const formQuestion = arrayFind(section.questions, 'Q' + qIds[0] + '-' + qIds[1], 'questionId');
    const topSubQuestion = arrayFind(formQuestion.subQuestions, 'Q' + qIds[0] + '-' + qIds[1] + '-' + qIds[2], 'questionId');
    const index = arrayFindIndex(topSubQuestion.subQuestions, question.questionId, 'questionId');

    topSubQuestion.subQuestions.splice(index, 1, question);
    return newApp;
};

export const fix = (num, length = 3) => {
    return ('' + num).length < length ? ((new Array(length + 1)).join('0') + num).slice(-length) : '' + num;
};

export const getInputContent = (userAnswer) => {
    return (userAnswer &&
        userAnswer.contents &&
        userAnswer.contents.length > 0 &&
        userAnswer.contents[0]);
};

export const regenSubQuestionId = (question) => {
    const { subQuestions, questionId, answers } = question;

    // regen question id
    subQuestions && subQuestions.forEach((subQuestion, index) => {
        subQuestion.questionId = `${questionId}-${fix(index + 1)}`;
        // const [originIndicator, ] = subQuestion.questionIndicator.split('_');
        // if (index === 0) {
        //     subQuestion.questionIndicator = originIndicator
        // } else {
        //     subQuestion.questionIndicator = `${originIndicator}_${index}`
        // }
        subQuestion.index = index + 1;
        // regen userAnswer
        const { userAnswer } = subQuestion;
        if (userAnswer && userAnswer.chosenAnswerId) {
            const reGenAnswers = userAnswer.chosenAnswerId.split(',').map(value => {
                const [, answerIndex] = value.split(":");
                return `${subQuestion.questionId.replace('Q', 'A')}:${answerIndex}`;
            });
            subQuestion.userAnswer = {
                chosenAnswerId: reGenAnswers.join()
            }
        }
        regenSubQuestionId(subQuestion);
    });

    // regen answer id
    answers && answers.forEach((answer, index) => {
        answer.answerId = `${questionId.replace('Q', 'A')}:${fix(index + 1)}`;
        answer.index = index + 1;
        answer.parentId = questionId;
    })
};

export const cloneQuestion = (question) => {
    if (question) {
        const newQuestion = deepClone(question);
        removeRepeatableSubQuestion(newQuestion);
        clearQuestionAnswer(newQuestion);
        newQuestion.questionStatus = 0;
        return newQuestion;
    }
    return null;
};

export const clearQuestionAnswer = (question) => {
    if (question) {
        question.userAnswer = null;
        const { subQuestions } = question;
        subQuestions && subQuestions.forEach(item => {
            clearQuestionAnswer(item)
        })
    }
};

// reduce repeatable sub-questions to one sub-question in new clone question
export const removeRepeatableSubQuestion = (question) => {
    if (question) {
        question.subQuestions && question.subQuestions.forEach(subQuestion => {
            if ((subQuestion.answerType === 14 || subQuestion.answerType === 17 || subQuestion.answerType === 18)
                && subQuestion.subQuestions.length > 1) {
                subQuestion.subQuestions.splice(1, subQuestion.subQuestions.length - 1)
            }
        })
    }
};

export const checkSubQuestionCondition = (app, question) => {
    let result = false;
    const { condition } = question;
    const conditionObj = condition && JSON.parse(condition);
    const subQuestionCondition = conditionObj && conditionObj.subQuestionCondition;
    const validations = conditionObj && conditionObj.validations;

    if (subQuestionCondition) {
        if (subQuestionCondition.type === "subQuestionCondition") {
            result = isSubQuestionMatch(app, question, subQuestionCondition)
        } else if (subQuestionCondition.type === "relationship") {
            const { relation } = subQuestionCondition;
            let localResult = null;
            subQuestionCondition.conditions.forEach(value => {
                if (localResult) {
                    if (relation === "and") {
                        localResult = localResult && isSubQuestionMatch(app, question, value)
                    } else {
                        localResult = localResult || isSubQuestionMatch(app, question, value)
                    }
                } else {
                    localResult = isSubQuestionMatch(app, question, value)
                }
            });
            result = localResult;
        } else if (subQuestionCondition.type === "matchYearsSubQuestionCondition") {
            const { answer } = subQuestionCondition;
            const { createTime } = getSessionDatas();
            if (question && question.userAnswer && !isStringEmpty(createTime)) {
                const defaultValue = question.userAnswer ? getInputContent(question.userAnswer) : "--";
                const dates = defaultValue.split("-");
                let isError = false;
                dates.forEach(value => {
                    if (!(new RegExp('.+').test(value))) {
                        isError = true
                    }
                });
                if (!isError && isDate(dates[2], dates[1], dates[0])) {
                    let validationResult = false;
                    let userDate = covertStringToDate(defaultValue);
                    if (validations) {
                        const length = validations.length;
                        for (let i = 0; i < length; i++) {
                            const validation = validations[i];
                            const { type } = validation;
                            const now = new Date();
                            if (type === 0) {
                                if (now >= userDate) {
                                    validationResult = true
                                }
                            } else if (type === 11) {
                                if (now <= userDate) {
                                    validationResult = true
                                }
                            }
                        }
                    }
                    if (validationResult) {
                        userDate.setFullYear(userDate.getFullYear() + parseInt(answer, 0));
                        result = userDate > new Date(createTime)
                    }
                }
            }
        }
    }
    return result;
};

export const isConnectedParties = (question, isPanelLevel = false) => {
    let result = false;
    const {qIds} = parseId(question.questionId);
    const isIdLengthMatch = isPanelLevel ? qIds.length === 3 : qIds.length > 1;
    if (isIdLengthMatch && qIds[0] === '003' && qIds[1] === '007') {
        result = true
    }
    return result
};

const isSubQuestionMatch = (app, question, subQuestionCondition) => {
    let result = false;
    const { userAnswer } = question;
    if (!userAnswer) { return result }
    if (userAnswer.chosenAnswerId) {
        const answers = userAnswer.chosenAnswerId.split(",");
        let targetId = subQuestionCondition.answer;
        if (targetId && targetId.indexOf("*") !== -1 && targetId.indexOf(":") !== -1) {
            targetId = question.questionId.replace('Q', 'A') + ":" + targetId.split(":")[1]
        }
        const { operator } = subQuestionCondition;
        let notEqualCount = 0;
        answers.forEach(value => {
            if (operator === "eq") {
                if (value === targetId) {
                    result = true;
                }
            } else if (operator === "not") {
                if (value !== targetId) {
                    result = true;
                } else {
                    notEqualCount = 1
                }
            }
        });
        if (operator === "not" && notEqualCount > 0) {
            result = false
        }
    } else if (userAnswer.contents) {

    }
    return result;
};

// check subQuestionId whether or not come from question
export const isSubQuestionWithinQuestion = (question, subQuestionId) => {
    const { qIds } = parseId(question.questionId);
    const { qIds: sqIds } = parseId(subQuestionId);
    const questionLevel = qIds.length;
    const subQuestionLevel = sqIds.length;
    let result = false;

    if (subQuestionLevel > questionLevel) {
        let levelMatchFlag = 0;
        qIds.forEach((id, index) => {
            if (id !== sqIds[index]) {
                levelMatchFlag++
            }
        });
        result = levelMatchFlag === 0
    }
    return result
};

export const documentCheckListQuestionShouldDisplay = (app, question) => {
    let result = false;
    const { condition, questionIndicator } = question;
    const conditionObj = condition && JSON.parse(condition);
    const displayCondition = conditionObj && conditionObj.displayCondition;
    if (displayCondition) {
        result = isAOFormConditionMatch(app, displayCondition, question, true);
    } else {
        result = true;
    }
    
    if (app.companyInfo && app.companyInfo.registerCountry !== 'CN' && questionIndicator === 'MenuLegRepIDFile') {
        result = false;
    }
    return result;
};

export const aoformAnswerShouldDisplay = (app, answer) => {
    return aoformQuestionShouldDisplay(app, answer)
}

export const aoformQuestionShouldDisplay = (app, question) => {
    let result = false;
    const { condition } = question;
    const conditionObj = condition && JSON.parse(condition);
    const displayCondition = conditionObj && conditionObj.displayCondition;
    if (displayCondition) {
        result = isAOFormConditionMatch(app, displayCondition, question, false);
    } else {
        result = true;
    }
    return result;
};


export const shouldDisplayDefaultValue = (app, question) => {
    let result = true; // default is show the default value
    const { condition, questionIndicator, questionId } = question;
    const conditionObj = condition && JSON.parse(condition);
    // special handling for Q003-005
    if (questionIndicator === "CountryBusinessIsSubToTaxRes") {
        if (questionId !== 'Q003-005-001-001-001') {
            return false
        }
    }
    if (conditionObj && conditionObj.defaultValue && conditionObj.defaultValue.condition) {
        const defaultValueConditionObj = conditionObj.defaultValue.condition;
        if (defaultValueConditionObj) {
            result = isAOFormConditionMatch(app, defaultValueConditionObj, question);
        }
    }
    return result;
};

export const isAOFormConditionMatch = (app, fieldCondition, originQuestion, matchForNullAnswer) => {
    let result = false;
    if (fieldCondition.type === 'condition') {
        const targetId = fieldCondition.questionId;
        let condition = fieldCondition;

        let userAnswer = null;
        if (targetId.indexOf('companyInfo:') !== -1) {
            const key = targetId.split(':')[1]
            userAnswer = { "chosenAnswerId": app.companyInfo[key] }
        } else {
            if (targetId.indexOf("*") !== -1) {
                const { isMatchAll } = fieldCondition;
                if (typeof(isMatchAll) !== "undefined" && isMatchAll) {
                    return handleMatchAllIdTemplate(app, fieldCondition, originQuestion, matchForNullAnswer)
                } else {
                    condition = handleIdTemplate(app, fieldCondition, originQuestion)
                }
            }
            const question = findQuestionById(app, condition.questionId);
            userAnswer = question && question.userAnswer;
        }
        if (userAnswer) {
            const { operator } = condition;
            if (userAnswer.chosenAnswerId || userAnswer.chosenAnswerId === "") {
                const answers = userAnswer.chosenAnswerId.split(",");
                let notEqualCount = 0;
                answers.forEach(value => {
                    if (operator === "eq") {
                        if (value === condition.answer) {
                            result = true;
                        }
                    } else if (operator === "not") {
                        if (value !== condition.answer) {
                            result = true;
                        } else {
                            notEqualCount = 1
                        }
                    }
                });
                if (operator === "not" && notEqualCount > 0) {
                    result = false
                }
            } else {
                if (userAnswer.contents) {
                    if (userAnswer.contents.length > 0) {
                        if (operator === "eq") {
                            if (userAnswer.contents[0] === condition.answer) {
                                result = true;
                            }
                        } else if (operator === "not") {
                            if (userAnswer.contents[0] !== condition.answer) {
                                result = true;
                            }
                        }
                    }
                } else {
                    if (operator === "not") {
                        result = true
                    }
                }
            }
        }else if(matchForNullAnswer){
            result = true;
        } else if (condition.operator === "not") {
            result = condition.answer !== ""
        } else if (condition.operator === "eq") {
            result = condition.answer === ""
        }
    } else if (fieldCondition.type === 'relationship') {
        let localResult = null;
        fieldCondition.conditions.forEach(element => {
            if (localResult === null) {
                localResult = isAOFormConditionMatch(app, element, originQuestion, matchForNullAnswer);
            } else {
                if (fieldCondition.relation === 'and') {
                    localResult = localResult && isAOFormConditionMatch(app, element, originQuestion, matchForNullAnswer);
                } else {
                    localResult = localResult || isAOFormConditionMatch(app, element, originQuestion, matchForNullAnswer);
                }
            }
        });
        result = localResult;

    } else if (fieldCondition.type === 'sourceOfWealthCondition') {
        const { questionId, answer } = fieldCondition;
        const { createTime } = getSessionDatas();
        const targetQuestion = findQuestionById(app, questionId);
        if (targetQuestion && targetQuestion.userAnswer && !isStringEmpty(createTime)) {
            const contents = targetQuestion.userAnswer.contents;
            if (contents && contents.length > 0) {
                let time = covertStringToDate(contents[0]);
                time.setFullYear(time.getFullYear() + parseInt(answer, 0));
                result = time > new Date(createTime)
            }
        }
    }
    return result;
};

export const checkPercentage = (app, question, type) => {
    let sum = 0;
    let isSkip = false;
    let subQuestionList = [];
    const { condition, userAnswer, subQuestions, questionId } = question;

    const conditionObj = condition && JSON.parse(condition);
    if (conditionObj && conditionObj.validations) {
        const { validations } = conditionObj;
        validations && validations.forEach(validation => {
            if (aoformQuestionShouldDisplay(app, question)){
                if (type === validation.type && userAnswer) {
                    sum += parseInt(getInputContent(userAnswer) || "0", 0);
                    subQuestionList.push(questionId);
                }
            } else {
                isSkip = true;
            }
        })
    }

    if (subQuestions && !isSkip) {
        subQuestions.forEach(subQuestion => {
            const [tempSum, tempSubQuestionList] = checkPercentage(app, subQuestion, type);
            sum += tempSum;
            subQuestionList.push(...tempSubQuestionList);
        })
    }
    return [sum, subQuestionList];
};

export const aoformValidationShouldDisplay = (app, question) => {
    let result = false;
    let errorMsg = '';
    const { condition } = question;
    const conditionObj = condition && JSON.parse(condition);

    if (conditionObj && conditionObj.validations) {
        const { validations } = conditionObj;
        validations && validations.forEach(validation => {
            const { displayCondition, errorLocales } = validation;
            if (displayCondition) {
                result = isAOFormConditionMatch(app, displayCondition, question, false);
                errorMsg = errorLocales;
            }
        })
    }
    return [result, errorMsg];
}
//is show the error for the questionId of the errorCondition 
export const aoformValidationErrorCondition = (question, errorList) => {
    const { condition } = question;
    const conditionObj = condition && JSON.parse(condition);
    const { errorCondition } = conditionObj;
    const targetId = errorCondition.questionId;
    let fieldCondition = errorCondition;
    let result = false;
    if (targetId.indexOf('*') !== -1) { 
        fieldCondition = handleIdTemplate({}, fieldCondition, question)
    }
    if (fieldCondition.type === 'delete') {
        const itemIndex = errorList.indexOf(fieldCondition.questionId);
        const isEmptyAnswer = getUserAnswer(question) === '';
        if (itemIndex !== -1 && isEmptyAnswer) {
            errorList.splice(itemIndex, 1);
            result = true;
        }
    }
    return result;
}

const getUserAnswer = (question) => {
    const { userAnswer, answerType } = question;
    let userAnswerTmp = null;
    switch (answerType) {
        case 4: // Input
        case 21: // InputDigit
        case 24: // TextArea
        case 23: // InputPercentage
            userAnswerTmp = getInputContent(userAnswer);
            break;
        case 2: //checkbox
            userAnswerTmp = userAnswer && userAnswer.chosenAnswerId;
            break;
        default:
            break;
    }
    return userAnswerTmp;
}

export const handleIdTemplate = (app, fieldCondition, question) => {
    const { questionId } = question;
    const needMatchId = fieldCondition.questionId;
    const splitIds = needMatchId.split("*");
    if (splitIds.length === 2) {
        const rex = /^-|-$/g;
        const replaceString = questionId.substring(splitIds[0].length).replace(rex, '').split("-")[0];
        fieldCondition.questionId = fieldCondition.questionId.replace("*", replaceString);
        if (fieldCondition.answer) {
            fieldCondition.answer = fieldCondition.answer.replace("*", replaceString);
        }
        // const parentId = splitIds[0].replace(rex, '').replace('A', 'Q');
        // const trail = splitIds[1].replace(rex, '');
        // const parentQuestion = findQuestionById(app, parentId)
        // const matchIds = parentQuestion.subQuestions && parentQuestion.subQuestions.map((question, index) => {
        //     return `${prefix}${parentId.splice(0, 1)}-${fix(index + 1)}-${trail}`
        // })
    }
    return fieldCondition
};

const handleMatchAllIdTemplate = (app, fieldCondition, question, matchForNullAnswer) => {
    const needMatchId = fieldCondition.questionId;
    const splitIds = needMatchId.split("*");
    if (splitIds.length === 2) {
        const rex = /^-|-$/g;
        const parentId = splitIds[0].replace(rex, '');
        const trail = splitIds[1].replace(rex, '');
        const parentQuestion = findQuestionById(app, parentId);
        const matchConditions = parentQuestion && parentQuestion.subQuestions && parentQuestion.subQuestions.map((question, index) => {
            let tempCondition = deepClone(fieldCondition);
            tempCondition.questionId = `${parentId}-${fix(index + 1)}-${trail}`;
            tempCondition.answer = fieldCondition.answer.replace("*", fix(index + 1));
            return tempCondition;
        });

        if (fieldCondition.operator === 'sumlt') {
            let sum = 0
            matchConditions.forEach(condition => {
                const { questionId } = condition;
                const tempQuestion = findQuestionById(app, questionId)
                if (tempQuestion) {
                    sum += parseInt(getInputContent(tempQuestion.userAnswer) || "0", 0)
                }
            })
            return sum < parseInt(fieldCondition.answer || '100', 10)
        } else {
            let localResult = null;
            matchConditions.forEach(condition => {
                if (localResult === null) {
                    localResult = isAOFormConditionMatch(app, condition, question, matchForNullAnswer);
                } else {
                    localResult = localResult || isAOFormConditionMatch(app, condition, question, matchForNullAnswer);
                }
            });

            return localResult
        }
    }

    return false;
};

export const findPreviousOrNextQuestionId = (app, id, isPre) => {
    const pId = findQuestionParentId(id);

    const pQuestion = findQuestionById(app, pId);
    const subQuestions = pQuestion.subQuestions?pQuestion.subQuestions:pQuestion.questions;
    const index = arrayFindIndex(subQuestions, id, 'questionId');

    if (isPre) {
        // const previousIndex = index - 1;
        const previousIndex = id === 'Q003-006' ? index + 1 : (id === 'Q003-007' ? index - 2 : index - 1);
        if (previousIndex >= 0) {
            const previousQuestion = subQuestions[previousIndex];
            return previousQuestion.questionId ? previousQuestion.questionId : previousQuestion.sectionId;
        } else {
            return null;
        }
    } else {
        // const nextIndex = index + 1;
        const nextIndex = id === 'Q003-005' ? index + 2 : (id === 'Q003-007' ? index - 1 : index + 1);
        if (nextIndex < subQuestions.length && id !== 'Q003-006') {
            const nextQuestion = subQuestions[nextIndex];
            return nextQuestion.questionId ? nextQuestion.questionId : nextQuestion.sectionId;
        } else {
            return null;
        }
    }
};

export const getCountryIdByQuestionIdAndIndicator = (questionId, indicator, countryList) => {
    const baseId = questionId.replace('Q', 'A') + ":"
    let index = 0
    for (let i = 0; i < countryList.length; i++) {
        const country = countryList[i]
        if (indicator === country.indicator) {
            index = i;
            break;
        }
    }
    return baseId + fix(index + 1)
}

export const getAreaCodeIdByQuestionIdAndIndicator = (questionId, indicator, countryList) => {
    const baseId = questionId.replace('Q', 'A') + ":"
    let index = 0
    for (let i = 0; i < countryList.length; i++) {
        const country = countryList[i]
        if (indicator === country.indicator) {
            index = i;
            break;
        }
    }
    return baseId + fix(index + 1)
}

export const getIndustryLevelIdByQuestionIdAndIndicator = (question, indicator, industryLevelList) => {
    const questionId = question.questionId
    const questionIndicator = question.questionIndicator
    const baseId = questionId.replace('Q', 'A') + ":"
    let industryLevelItem = null
    let index = 0
    if(questionIndicator === "natureBusi"){
        industryLevelList.forEach((item,i)=>{
            if (indicator === item.indicator) {
                index = i;
                _tempItem = item
                //sessionStorage.setItem("industryLevelItem", JSON.stringify(item));
            }
        })
    }else if(questionIndicator === "manufactures"){
        //industryLevelItem = JSON.parse(sessionStorage.getItem("industryLevelItem"));
        industryLevelItem = _tempItem
        if(index >= 0){
            industryLevelItem.children.forEach((item,i)=>{
                if (indicator === item.indicator) {
                    index = i;
                    _tempItem = item
                }
            })
        }
    }else if(questionIndicator === "thirdNature"){
        //industryLevelItem = JSON.parse(sessionStorage.getItem("industryLevelItem"));
        industryLevelItem = _tempItem
        if(index >= 0){
            industryLevelItem.children.forEach((item,i)=>{
                if (indicator === item.indicator) {
                    index = i;
                    _tempItem = null
                }
            })
        }
    }
    return baseId + fix(index + 1)
}
//RBBOB-15726 AC2
export const getResOrBusOpeSitCodeLevelIdByQuestionIdAndIndicator = (question, indicator, resOrBusOpeSitCodeLevelDatasRoots) => {
    const questionId = question.questionId
    const questionIndicator = question.questionIndicator
    const baseId = questionId.replace('Q', 'A') + ":"
    let industryLevelItem = null
    let index = 0
    if(questionIndicator === "resOrBusOpeSitCodeLevel1"){
        resOrBusOpeSitCodeLevelDatasRoots.forEach((item,i)=>{
            if (indicator === item.indicator) {
                index = i;
                _tempItem = item
            }
        })
    }else if(questionIndicator === "resOrBusOpeSitCodeLevel2"){
        industryLevelItem = _tempItem
        if(index >= 0){
            industryLevelItem.children.forEach((item,i)=>{
                if (indicator === item.indicator) {
                    index = i;
                    _tempItem = item
                }
            })
        }
    }else if(questionIndicator === "resOrBusOpeSitCodeLevel3"){
        industryLevelItem = _tempItem
        if(index >= 0){
            industryLevelItem.children.forEach((item,i)=>{
                if (indicator === item.indicator) {
                    index = i;
                    _tempItem = null
                }
            })
        }
    }
    return baseId + fix(index + 1)
}

const findQuestionParentId = (qId) => {
    const ids = qId.split('-');
    ids.pop();
    return ids.join('-');
};

// special handling for Q003-005
export const checkDuplicateByQuestionIndicator = (section, indicator) => {
    let duplicateList = []
    let errorList = []
    const { subQuestions } = section;
    const checkSubQuestions = (subQuestions, duplicateList) => {
        if (!!subQuestions) {
            subQuestions.forEach(obj => {
                const { questionIndicator, subQuestions, questionId, userAnswer } = obj;
                if (indicator === questionIndicator) {
                    if (!!userAnswer && !!userAnswer.chosenAnswerId) {
                        const [, answerIndex] = userAnswer.chosenAnswerId.split(":")
                        if (duplicateList.indexOf(answerIndex) !== -1) {
                            errorList.push(questionId)
                        } else {
                            duplicateList.push(answerIndex)
                        }
                    } else if (!!userAnswer && !!userAnswer.contents && userAnswer.contents[0] !== "") {
                        const answerIndex = userAnswer.contents[0];
                        if (duplicateList.indexOf(answerIndex) !== -1) {
                            errorList.push(questionId)
                        } else {
                            duplicateList.push(answerIndex)
                        }
                    }
                }
                checkSubQuestions(subQuestions, duplicateList)
            })
        }
    }
    checkSubQuestions(subQuestions, duplicateList)
    return errorList
}


// WEBPACK FOOTER //
// ./src/utils/AOFormUtils.js